import React from "react";

import PlayIcon from "public/icons/play_circle.svg";

import { css, styled } from "@mui/material";

import { SvgIcon } from "@/components/ui/svg-icon/SvgIcon";
import { WithClassName } from "@/models/utils.models";
import { skipForwardProp } from "@/utils/skipForwardProp";
import { clsxm } from "@/utils/tailwindMerge";

type StyledPropTypes = {
  ignoreNotDisplayingOnMobile?: boolean;
};

const PlayButtonPlaceholder = styled("div", {
  shouldForwardProp: skipForwardProp(["ignoreNotDisplayingOnMobile"]),
})<StyledPropTypes>(({ ignoreNotDisplayingOnMobile }) => {
  return css`
    position: absolute;
    inset: 0;
    cursor: pointer;

    margin: unset !important;
    width: unset !important;
    height: unset !important;
    min-height: 50px;
    ${!ignoreNotDisplayingOnMobile &&
    `
      @media (pointer: coarse) {
        & {
          display: none !important;
        }
      }
      
    `}
  `;
});

type PropTypes = WithClassName & {
  onClick?: () => void;
  ignoreNotDisplayingOnMobile?: boolean;
};

export const PlayCircleIcon: React.FC<PropTypes> = ({
  onClick,
  className,
  ignoreNotDisplayingOnMobile,
}) => {
  return (
    <PlayButtonPlaceholder
      className={clsxm(className)}
      onClick={onClick}
      ignoreNotDisplayingOnMobile={ignoreNotDisplayingOnMobile}
    >
      <div
        data-testid="playCircleButton"
        className="left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 absolute flex justify-center items-center"
      >
        <SvgIcon className="w-12 h-12 max-w-[90%] max-h-[90%]">
          <PlayIcon />
        </SvgIcon>
      </div>
    </PlayButtonPlaceholder>
  );
};
